import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { trackCustomMarketplaceOfferingBehavioralEvent } from '../utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function DefaultButton() {
  const {
    appContext,
    published,
    productType
  } = useDetailsPageContext();
  const isPreview = !published;
  const buttonText = appContext === 'public' ? `detailsPage.productDetailsCard.cta.signIn.${productType}` : `detailsPage.productDetailsCard.cta.install.${productType}`;
  return /*#__PURE__*/_jsx(Button, {
    use: "primary",
    disabled: isPreview,
    onClick: () => {
      trackCustomMarketplaceOfferingBehavioralEvent('HEADER_CONNECT');
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: buttonText
    })
  });
}